import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';

// Récupérer la langue depuis localStorage ou utiliser la langue par défaut
const storedLanguage = import.meta.env.SSR
  ? null
  : (localStorage.getItem('language') as 'en' | 'fr' | null);
const defaultLanguage = storedLanguage ?? 'fr';

void i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    lng: defaultLanguage,
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
  });



export {default} from 'i18next';